import { getCsrfToken } from "next-auth/react";

type IsInternalRes = { isInternal: boolean } | { error: string };

export const checkIsInternal = async ({
  email,
  phone,
}: {
  email: string;
  phone: string;
}): Promise<IsInternalRes | undefined> => {
  const csrfToken = await getCsrfToken();

  const res = await fetch(
    `/api/auth/is-internal?phone=${encodeURIComponent(
      phone
    )}&email=${encodeURIComponent(email)}&csrf_token=${csrfToken}`
  );

  return res.json();
};
